// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CommentCitationLinks.test.tsx
// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.comment-sources.spec.ts
import { ArrowSquareOut } from "@phosphor-icons/react";
import { Dialog, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { CITATION_CHIP_CLASS } from "./citationChipStyles";

import {
  KnowledgeRuleCitationDialog,
  knowledgeRuleCitationLabel,
} from "../../../../components/KnowledgeRuleCitationDialog";
import {
  type TicketMessageCitation,
  isKnowledgeRuleCitation,
} from "../../utils/commentSourceUtils";

/**
 * A citation to a synthesized Knowledge Database rule (`knowledgerules`) — e.g.
 * an approved claim. The chip is self-describing: the citation carries its own
 * `quote` / `statement`, so unlike the KDB-record chip this needs no follow-up
 * fetch. The dialog shows the cited wording and deep-links into the Rules tab.
 */
export function KnowledgeRuleCitationLink({
  citation,
}: {
  citation: TicketMessageCitation;
}) {
  const { t } = useTranslation("ui");
  if (!isKnowledgeRuleCitation(citation)) return null;

  const label = knowledgeRuleCitationLabel(
    citation,
    t("commentCitationLinks.knowledgeRule"),
  );
  const sourceName = citation.sourceName?.trim();

  return (
    <KnowledgeRuleCitationDialog citation={citation}>
      <Dialog.Trigger>
        <button
          type="button"
          data-testid="comment-panel-knowledge-rule-citation"
          aria-label={t("commentCitationLinks.knowledgeRuleCitation")}
          className={CITATION_CHIP_CLASS}
        >
          <Text as="span" size="1" weight="medium">
            {label}
          </Text>
          {sourceName ? (
            <Text
              as="span"
              size="1"
              className="text-puntt-neutral-gray-11"
              data-testid="knowledge-rule-citation-source"
            >
              {`· ${sourceName}`}
            </Text>
          ) : null}
          <ArrowSquareOut size={12} aria-hidden="true" />
        </button>
      </Dialog.Trigger>
    </KnowledgeRuleCitationDialog>
  );
}
